<template>
  <div class="hijo-card">
    <div class="image-wrapper">
      <a href="#" @click.prevent="openPhotoSwipe" class="pswp-trigger">
        <img :src="hijo.foto_url" class="card-img" :alt="hijo.nombre_hijo" />
      </a>
      <div class="ribbon">📸 FOTO</div>
    </div>
    <div class="card-body">
      <h5 class="nombre-hijo">{{ hijo.nombre_hijo }}</h5>
      <div class="glow-divider"></div>
      <ul class="datos">
        <li><span class="label">👨 Padre:</span> {{ hijo.nombre_padre || '—' }}</li>
        <li><span class="label">👩 Madre:</span> {{ hijo.nombre_madre || '—' }}</li>
        <li><span class="label">🌎 Departamento:</span> {{ hijo.departamento || '—' }}</li>
        <li><span class="label">🏙️ Ciudad:</span> {{ hijo.ciudad || '—' }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'

const props = defineProps({ hijo: Object })
let lightbox

function openPhotoSwipe() {
  // Destruye lightbox anterior si existe
  if (lightbox) {
    lightbox.destroy()
  }

  lightbox = new PhotoSwipeLightbox({
    dataSource: [
      {
        src: props.hijo.foto_url,
        width: 1200,
        height: 800,
        alt: props.hijo.nombre_hijo
      }
    ],
    pswpModule: () => import('photoswipe')
  })

  lightbox.init()
  lightbox.loadAndOpen(0)
}

onBeforeUnmount(() => {
  if (lightbox) {
    lightbox.destroy()
    lightbox = null
  }
})
</script>

<style scoped>
* {
  font-family: 'ColgateReady-Regular', sans-serif;
}

.hijo-card {
  background: #fff;
  border-radius: 1.6rem;
  overflow: hidden;
  position: relative;
  transition: transform 0.4s ease, box-shadow 0.3s ease;
  box-shadow: 0 16px 32px rgba(68, 52, 102, 0.12);
  border: 2px solid transparent;
}

.hijo-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 24px 40px rgba(68, 52, 102, 0.2);
  border-color: #ee124c;
}

.image-wrapper {
  position: relative;
  overflow: hidden;
}

.card-img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-top-left-radius: 1.6rem;
  border-top-right-radius: 1.6rem;
  transition: transform 0.4s ease;
}

.hijo-card:hover .card-img {
  transform: scale(1.05);
}

.ribbon {
  position: absolute;
  top: 12px;
  left: -30px;
  transform: rotate(-45deg);
  background-color: #ee124c;
  color: #fff;
  font-size: 0.7rem;
  font-weight: bold;
  padding: 6px 50px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.2);
  z-index: 1;
}

.card-body {
  padding: 1.4rem 1.2rem;
  text-align: center;
  position: relative;
}

.nombre-hijo {
  font-size: 1.5rem;
  font-weight: 900;
  color: #443466;
  margin-bottom: 0.4rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.glow-divider {
  width: 60px;
  height: 4px;
  background: #ee124c;
  border-radius: 10px;
  margin: 0 auto 1rem;
  box-shadow: 0 0 8px #ee124caa;
  animation: glowin 1s ease-out;
}

@keyframes glowin {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 60px;
    opacity: 1;
  }
}

.datos {
  list-style: none;
  padding: 0;
  color: #322846;
  font-size: 1rem;
  text-align: left;
  margin: 0 auto;
  max-width: 90%;
}

.datos li {
  margin-bottom: 0.3rem;
}

.label {
  font-weight: 600;
  color: #ee122a;
}
</style>
